import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { action } from 'mobx';
import { LocalDoctorService } from 'application/import/services';
import { FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeForm } from 'application/facility-order-new-flow/forms';
import _ from "lodash";

class PatientTemplateCustomOrderingDoctorChangeModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const patientTemplate = componentProps.modalParams.data.patientTemplate;
        const patientTemplateService = componentProps.modalParams.data.patientTemplateService;
        super(rootStore, {
            name: 'patient-template-custom-ordering-doctor-change-modal',
            Form: FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeForm,
            authorization: 'portalSection.update',
            FormClass: FacilityOrderTemplateNewFlowCustomOrderingDoctorChangeForm,
            autoInit: false
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.patientTemplate = patientTemplate;
        this.patientTemplateService = patientTemplateService;
        this.localDoctorService = new LocalDoctorService(rootStore.application.baasic.apiClient);

        this.doctorStore = new BaasicDropdownStore({
            textField: 'orderingDoctor',
            filterable: true,
            returnObject: true,
        }, {
            fetchFunc: async (term) => {
                const response = await this.localDoctorService.find({ searchQuery: term, rpp: 20, isNiko: true });

                _.extend(response.data,
                    {
                        item: _.map(response.data.item, (item => {
                            return _.extend(
                                item, {
                                orderingDoctor: item.name + " - " + item.npi + (item.primaryAddressState ? " - " + item.primaryAddressState : ""),
                            }
                            );
                        }))
                    }
                );

                return response.data.item;
            }
        });

        this.form.clear();
        this.form.$("customOrderingDoctorId").value = this.patientTemplate.customOrderingDoctorId;
    }

    @action.bound
    async createResource(resource) {
        this.patientTemplate.customOrderingDoctorId = resource.customOrderingDoctorId;
        this.patientTemplateService.updateCustomOrderingDoctor(this.patientTemplate);
        this.modalParams.close();
    }
}
export default PatientTemplateCustomOrderingDoctorChangeModalStore;
